import { Injectable, OnDestroy } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase/app';
import { AngularFireDatabase } from '@angular/fire/database';

import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // _______ properties
  public firebaseUser:Observable<firebase.User>
  public userId:string;



  constructor(
    public _AngularFireAuth: AngularFireAuth,
    public _AngularFireDatabase: AngularFireDatabase,
    private _snackBar: MatSnackBar,

  ) { 
    this.firebaseUser = _AngularFireAuth.user
   }


  signUp(email:string,password:string) {
    // return this._AngularFireAuth.createUserWithEmailAndPassword(email,password)

    // return new Promise<any>((resolve, reject) => {
      return firebase.auth().createUserWithEmailAndPassword(email, password)
    //   .then(res => {
    //     resolve(res);
    //   }, err => reject(err))
    // })

    // from(firebase.auth().createUserWithEmailAndPassword(email, password))
    // .pipe(
    //   switchMap(({user})=> this._AngularFireDatabase.object(`metadata/${user.uid}/updatedAt`)
    //   .valueChanges()
    //   .pipe(
    //     first(updatedAt => !!updatedAt),
    //     mapTo(user)
    //     )
    //   ),
    //   take(1),
    //   switchMap(user => user.getIdToken(true))

    // ).subscribe( (x) => {
      
    // })




  }


  login(email:string,password:string) {
    return this._AngularFireAuth.signInWithEmailAndPassword(email,password)
  }


  doFacebookLogin(){
    return new Promise<any>((resolve, reject) => {
      let provider = new firebase.auth.FacebookAuthProvider();
      this._AngularFireAuth.signInWithPopup(provider)
      .then(res => {
        resolve(res);
      }, err => {
        reject(err);
      })
    })
 }




  doGoogleLogin() {
    return this._AngularFireAuth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }

  logout() {
    return this._AngularFireAuth.signOut()
  }


  resetPassword(emailAddress) {
   return this._AngularFireAuth.sendPasswordResetEmail(emailAddress)
  }




}
